export * from './operation-bed.service';